/**
 * Reveals `.academy-pill-mark` headline highlights (animated pill border)
 * once they scroll into view. Shared by Academy Hero, Academy Clip Mask,
 * Academy Bento, Academy Color Slider and Academy Upgrade Hero.
 *
 * <academy-upgrade-hero> drives its own reveal timing for its first-slide
 * headline (GSAP word fly-in, with a scroll-triggered fallback when GSAP
 * isn't available) via its own inline script, so this generic observer
 * skips marks inside that element to avoid fighting over the same class.
 * Any other component can opt out the same way by wrapping its marks in
 * an ancestor carrying [data-pill-manual] (e.g. Academy Parallax Scroll's
 * crossfade headline, which sequences its pill reveal to start only
 * after its academy-text-reveal finishes).
 *
 * Also re-scans when Shopify's theme editor injects a section via the
 * Section Rendering API (`shopify:section:load`) or any other script
 * mutates the DOM — <script> tags inside AJAX-injected HTML never run, so
 * a single scan at page load would silently miss marks added afterwards.
 */
if (!window.__academyPillMarkObserverInit) {
  window.__academyPillMarkObserverInit = true;

  (function () {
    'use strict';

    var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
    var noIO = !('IntersectionObserver' in window);

    var io = noIO ? null : new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.6 });

    function scan(root) {
      var marks = Array.from((root || document).querySelectorAll('.academy-pill-mark:not(.is-revealed)')).filter(function (el) {
        return !el.closest('academy-upgrade-hero') && !el.closest('[data-pill-manual]') && (!seen || !seen.has(el));
      });
      if (!marks.length) return;

      if (noIO) {
        marks.forEach(function (el) { el.classList.add('is-revealed'); });
        return;
      }

      marks.forEach(function (el) {
        if (seen) seen.add(el);
        io.observe(el);
      });
    }

    function init() {
      scan();

      document.addEventListener('shopify:section:load', function (event) {
        scan(event.target);
      });

      if ('MutationObserver' in window) {
        var mo = new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            if (mutations[i].addedNodes.length) {
              scan();
              return;
            }
          }
        });
        mo.observe(document.body, { childList: true, subtree: true });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
}
